import { ClientSideActions } from "@/enums/clientSideActions.enum";
import type { Action, InterruptAction, RetryAction } from "@/types";

export abstract class BaseActionError<T extends ClientSideActions = ClientSideActions> extends Error {
  abstract readonly type: T;

  readonly action: Action;
  readonly context?: unknown;
  readonly error?: Error | null;

  protected constructor(message: string, params: { action: Action; context?: unknown; error?: Error | null; }) {
    super(message);
    this.action = params.action;
    this.context = params.context;
    this.error = params.error;
  }

  static create(action: Action, message: string, context?: unknown, error?: Error | null) {
    if (action.type === ClientSideActions.RETRY) {
      return new RetryActionError(action, message, context, error);
    }

    throw new Error(`No ActionError defined for type ${action.type}`);
  }
}

export class RetryActionError extends BaseActionError<ClientSideActions.RETRY> {
  readonly type = ClientSideActions.RETRY;

  constructor(action: RetryAction, message: string, context?: unknown, error?: Error | null) {
    super(message, { action, context, error });
  }
}

export class InterruptPipelineStepActionError extends BaseActionError<ClientSideActions.INTERRUPT> {
  readonly type = ClientSideActions.INTERRUPT;

  constructor(action: InterruptAction, message: string, context?: unknown, error?: Error | null) {
    super(message, { action, context, error });
  }
}

export class InterruptPipelineActionError extends BaseActionError<ClientSideActions.INTERRUPT> {
  readonly type = ClientSideActions.INTERRUPT;

  constructor(action: InterruptAction, message: string, context?: unknown, error?: Error | null) {
    super(message, { action, context, error });
  }
}

export class InterruptLifecycleActionError extends BaseActionError<ClientSideActions.INTERRUPT> {
  readonly type = ClientSideActions.INTERRUPT;

  constructor(action: InterruptAction, message: string, context?: unknown, error?: Error | null) {
    super(message, { action, context, error });
  }
}
